
import React from "react";
import NewsCarousel from "./work/NewsCarousel";

const Work = () => {
  console.log("[Work] Rendering Work component");

  return (
    <section className="relative py-16 px-4 md:px-8 bg-gray-50">
      <div className="max-w-[120rem] mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 bg-gradient-to-r from-[#0a2472] via-[#1e3a8a] to-[#2563eb] bg-clip-text text-transparent">
          Latest News
        </h2>
        <NewsCarousel />
      </div>
    </section>
  );
};

export default Work;
